var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasRW)?_c('Poptip',{attrs:{"transfer":"","confirm":"","title":_vm.popTitle,"disabled":_vm.loading,"placement":"top-end"},on:{"on-ok":_vm.onOk}},[(_vm.text)?_c('n-button',_vm._b({attrs:{"loading":_vm.loading}},'n-button',_vm.attrs,false)):_c('n-button-icon',_vm._b({attrs:{"loading":_vm.loading}},'n-button-icon',_vm.attrs,false))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }